// Add class js-observe-in-view to element that you want to observe
// Add data-fire-always="true" if you want to add and remove the in-view class every time the element appears

function inView(el) {
    const sections = [...document.querySelectorAll(el)];

    const options = {
        rootMargin: '0px',
        threshold: 0.25,
    };

    const callback = (entries) => {
        entries.forEach((entry) => {
            const fireAlways = entry.target.dataset.fireAlways;

            if (entry.intersectionRatio >= 0.25) {
                entry.target.classList.add('in-view');
            } else {
                if (fireAlways === 'true') {
                    entry.target.classList.remove('in-view');
                }
            }
        });
    };

    const observer = new IntersectionObserver(callback, options);

    sections.forEach((section) => {
        observer.observe(section);
    });
}

export default inView;
